import { adfModelTypeMap } from './../consts/adf-model-type-map-const';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';


export const sybaseTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.sybase.datasetType,
    displayName: stringResources.Sybase_DisplayText,
    supportLinkedServiceTypes: ['Sybase'],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Sybase'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database'],
    copySourceControls: [],
    copySinkControls: []
};
